import { AxiosError } from 'axios';
import { AuthUserState } from './auth';

export * from './auth';
export * from './myteam'

export interface ListResponseType<T> {
    data: Array<T>
    filtered_count: number
    total_count: number
}

export type RootState = {
    authUser: AuthUserState
}

export interface APIServerResponse<T> {
    StatusCode: number;
    Message: string;
    DevMessage: string | null;
    Body: T;
}

export interface ApiResponse<T> {
    code: number;
    message: string;
    data: T | null;
}

export class ResponseEntity<T>{
    code!: number;
    message!: string;
    data!: T | null;

    success(data: T, code?: number, message?: string): ApiResponse<T> {
        this.code = code || 200;
        this.message = message || '';
        this.data = data;
        return this.getResponse()
    }

    error(code: number, message: string, data?: T | null): ApiResponse<T> {
        this.code = code;
        this.message = message;
        this.data = data || null;
        return this.getResponse()
    }

    errorNew(error: AxiosError): ApiResponse<T> {
        const response: any = error.response || {};
        this.code = response.status || 500;
        this.message = response && response.data && response.data.message ? response.data.message : '';
        this.data = response.data && response.data ? response.data : null;
        return this.getResponse()
    }

    getResponse(): ApiResponse<T> {
        return {
            code: this.code,
            message: this.message,
            data: this.data as T,
        }
    }
}